import { observer } from "mobx-react";
import "./styles.scss";
import { UserDashboardWidgetModel } from 'shared/models';
import moment from 'moment/moment';

type PropsType = {
    widget: UserDashboardWidgetModel
}

const PROGRESS_COLORS = [
    { min: 80, color: "#22C55E" },
    { min: 50, color: "#FACC15" },
    { min: 20, color: "#FB923C" },
    { min: 0,  color: "#F43F5E" }
];

const polarToCartesian = (cx: number, cy: number, radius: number, angleInDegrees: number) => {
    const angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
    return {
        x: cx + radius * Math.cos(angleInRadians),
        y: cy + radius * Math.sin(angleInRadians)
    };
}

const describeArc = (x: number, y: number, radius: number, percent: number)=> {
    if (percent >= 100) {
        return `
            M ${x}, ${y}
            m -${radius}, 0
            a ${radius},${radius} 0 1,0 ${radius * 2},0
            a ${radius},${radius} 0 1,0 -${radius * 2},0
        `;
    }

    const startAngle = 360 - (percent / 100) * 360;
    const start = polarToCartesian(x, y, radius, startAngle);
    const end = polarToCartesian(x, y, radius, 360);
    const largeArcFlag = percent > 50 ? 1 : 0;

    return [
        "M", x, y,
        "L", start.x, start.y,
        "A", radius, radius, 0, largeArcFlag, 1, end.x, end.y,
        "Z"
    ].join(" ");
}

const pluralizeDaysGenitive = (num: number) => {
    const n = Math.abs(num) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) return "дней";
    if (n1 === 1) return "дня";
    return "дней";
}

export const PPDWidgetWorkdaysLeft = observer(({ widget }: PropsType) => {
    const days = widget.items;
    if (!days?.length) return null;

    const todayStr = days.find((d) => d.is_current)?.date || moment().format("YYYY-MM-DD");

    const currentIndex = days.findIndex(d => d.date === todayStr);

    const workdays = days.filter(d => d.is_workday);
    const total = workdays.length;

    const passed = days
        .slice(currentIndex)
        .filter(d => d.is_workday).length;

    const leftPercent = Math.round((passed / total) * 100);
    const color = PROGRESS_COLORS.find(c => leftPercent >= c.min)?.color || "#22C55E";

    const size = 32;
    const radius = size / 2;

    return (
        <div className="ppd-widget-workdays-left">
            <div className="ppd-widget-workdays-left__content">
                <span className="ppd-widget-workdays-left__label">Осталось работать</span>
                <div className="ppd-widget-workdays-left__counter">
                    <span className="ppd-widget-workdays-left__counter-value">
                        <span className="ppd-widget-workdays-left__number">{passed}</span>
                        <span className="ppd-widget-workdays-left__label">из</span>
                        <span className="ppd-widget-workdays-left__number">{total}</span>
                    </span>
                    <span className="ppd-widget-workdays-left__label">{pluralizeDaysGenitive(total)}</span>
                </div>
            </div>
            <div className="ppd-widget-workdays-left__icon">
                <svg
                    width={size}
                    height={size}
                    viewBox={`0 0 ${size} ${size}`}
                    shapeRendering="geometricPrecision"
                >
                    <circle cx={size / 2} cy={size / 2} r={radius} fill="#EAECF1" stroke="none" />
                    <path d={describeArc(size / 2, size / 2, radius, leftPercent)} fill={color} stroke="none" />
                </svg>
            </div>
        </div>
    );
});
